// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"d366ddc3","239":"e5bfa261","247":"e937be3d","283":"f0464317","658":"0ea1d9f8","824":"56a04fc1"}[chunkId] + ".chunk.js";
};